import { ref } from 'vue';
import type { VImg } from 'vuetify/components';

const useCoverDimensions = (defaultWidth?: number, defaultHeight?: number) => {
  const coverRef = ref<InstanceType<typeof VImg> | null>(null);
  const coverWidth = ref<number | undefined>(defaultWidth ?? 156);
  const coverHeight = ref<number | undefined>(defaultHeight ?? 156);
  const coverCardWidth = ref<string>('100%');
  const coverCardHeight = ref<string>('100%');

  const onImageLoaded = (maxWidth?: number, maxHeight?: number) => {
    if (!coverRef.value) return;

    const image = coverRef.value.$el.querySelector('img') as HTMLImageElement | null;

    if (!image) return;

    const naturalCoverWidth = image.naturalWidth;
    const naturalCoverHeight = image.naturalHeight;

    if (!maxWidth || !maxHeight) {
      coverWidth.value = undefined;
      coverHeight.value = undefined;
      coverCardWidth.value = '100%';
      coverCardHeight.value = '100%';
    } else {
      const originalWidthHeightRatio = naturalCoverWidth / naturalCoverHeight;
      const maxWidthHeightRatio = maxWidth / maxHeight;
      if (originalWidthHeightRatio > maxWidthHeightRatio) {
        coverWidth.value = maxWidth;
        coverHeight.value = maxWidth / originalWidthHeightRatio;
      } else {
        coverWidth.value = maxHeight * originalWidthHeightRatio;
        coverHeight.value = maxHeight;
      }

      coverCardWidth.value = coverWidth.value ? `${coverWidth.value}px` : '100%';
      coverCardHeight.value = coverHeight.value ? `${coverHeight.value}px` : '100%';
    }
  };

  return {
    coverRef,
    coverWidth,
    coverHeight,
    coverCardWidth,
    coverCardHeight,
    onImageLoaded,
  };
};

export default useCoverDimensions;
